module.exports = __webpack_public_path__ + "img/relearn-logo-only.82f25c52.png";